module.exports = __webpack_public_path__ + "img/6.88f081e4.png";